import styled from 'styled-components';

export const StyledMedicalLeaveDocumentErrorsStatus = styled.div`
   width: 100%;
`;
StyledMedicalLeaveDocumentErrorsStatus.displayName = 'StyledMedicalLeaveDocumentErrorsStatus';
